import { OUNode, Site, TreeNode } from '../types';

export function buildTree(nodes: OUNode[], sites: Site[]): TreeNode[] {
  const nodeMap = new Map<string, TreeNode>();

  nodes.forEach(n => {
    nodeMap.set(n.id, { ...n, children: [], sites: [] });
  });

  sites.forEach(s => {
    if (s.assignedNodeId && nodeMap.has(s.assignedNodeId)) {
      nodeMap.get(s.assignedNodeId)!.sites.push(s);
    }
  });

  const roots: TreeNode[] = [];
  nodeMap.forEach(node => {
    if (node.parentId === null) {
      roots.push(node);
    } else if (nodeMap.has(node.parentId)) {
      nodeMap.get(node.parentId)!.children.push(node);
    } else {
      roots.push(node);
    }
  });

  return roots;
}

export function flattenTree(nodes: TreeNode[]): TreeNode[] {
  const result: TreeNode[] = [];
  function walk(ns: TreeNode[]) {
    ns.forEach(n => {
      result.push(n);
      walk(n.children);
    });
  }
  walk(nodes);
  return result;
}

export function collectAllNodeIds(nodes: TreeNode[]): string[] {
  const ids: string[] = [];
  function walk(ns: TreeNode[]) {
    ns.forEach(n => {
      ids.push(n.id);
      walk(n.children);
    });
  }
  walk(nodes);
  return ids;
}

export function formatDate(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}
